module.exports = __webpack_public_path__ + "static/img/illus-07.8bb45b4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-07.webp
// module id = 108
// module chunks = 0